import {ADMIN_ROLES} from "../auth/roles";

export const COUNTRY_SCOPE_STORAGE_KEY = "sorpaAdminCountryScope";

export const ALL_COUNTRIES_SCOPE = "0";

const positiveCountryId = (value) => {
    const normalized = String(value ?? "").trim();
    return /^[1-9]\d*$/.test(normalized) ? normalized : null;
};

const normalizedCountryIds = (countryIds) =>
    Array.from(
        new Set((Array.isArray(countryIds) ? countryIds : []).map(positiveCountryId).filter(Boolean)),
    );

export const canUseGlobalCountryScope = (role) => role === ADMIN_ROLES.SUPERADMIN;

export const resolveAdminCountryScope = ({
    role,
    allowedCountryIds,
    storedScope,
    homeCountryId,
} = {}) => {
    const stored = String(storedScope ?? "").trim();
    if (canUseGlobalCountryScope(role)) {
        if (stored === ALL_COUNTRIES_SCOPE || positiveCountryId(stored)) return stored;
        return positiveCountryId(homeCountryId) || ALL_COUNTRIES_SCOPE;
    }

    const allowed = normalizedCountryIds(allowedCountryIds);
    const storedCountry = positiveCountryId(stored);
    return storedCountry && allowed.includes(storedCountry) ? storedCountry : allowed[0] || null;
};

export const getAdminCountryScope = () => {
    const storedScope = localStorage.getItem(COUNTRY_SCOPE_STORAGE_KEY);
    const role = localStorage.getItem("role");
    if (storedScope === ALL_COUNTRIES_SCOPE && !canUseGlobalCountryScope(role)) return null;
    if (storedScope === null || storedScope === "") return null;
    if (storedScope === ALL_COUNTRIES_SCOPE) return ALL_COUNTRIES_SCOPE;
    return positiveCountryId(storedScope);
};

export const setAdminCountryScope = (
    countryId,
    {
        role = localStorage.getItem("role"),
        allowedCountryIds = [],
        homeCountryId,
    } = {},
) => {
    const nextScope = resolveAdminCountryScope({
        role,
        allowedCountryIds,
        storedScope: countryId,
        homeCountryId,
    });
    if (nextScope === null) {
        localStorage.removeItem(COUNTRY_SCOPE_STORAGE_KEY);
        return null;
    }
    localStorage.setItem(COUNTRY_SCOPE_STORAGE_KEY, nextScope);
    window.dispatchEvent(
        new CustomEvent("sorpa-admin-country-scope-change", {detail: {countryId: nextScope}}),
    );
    return nextScope;
};

export const clearAdminCountryScope = () =>
    localStorage.removeItem(COUNTRY_SCOPE_STORAGE_KEY);
